'use client';
import { EmblaCarouselType } from 'embla-carousel';
import Image from 'next/image';
import { useState } from 'react';
import { VariantProps } from 'tailwind-variants';

import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import { UiModArtDirection } from '@/fo/ui/mod/art/direction';
import { staticMediaUrl } from '@/fo/util/image-loader';

import {
  InfoProduct,
  ProductSliderInfo
} from '../ProductSliderInfo/ProductSliderInfo';

import { styles } from './ProductSlider.styles';
type Variants = VariantProps<typeof styles>;
type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export type BannerProduct = {
  title: string;
  productImage: string;
  productImageMobile: string;
  mode: Variants['mode'];
  infoProduct: InfoProduct[];
};
export interface ProductSliderProps {
  titleSection: string;

  bannersProduct: BannerProduct[];
  onClick?: NativeElement['onClick'];
}

export function ProductSlider({
  titleSection,
  bannersProduct,
  ...props
}: ProductSliderProps) {
  const [activeSlide, setActiveSlider] = useState(0);
  const [emblaApi, setEmblaApi] = useState<EmblaCarouselType>();
  const slots = styles({ mode: bannersProduct[activeSlide]?.mode });
  const handleSlideChange = (index: number) => {
    setActiveSlider(index);
  };
  return (
    <div
      className={slots.base()}
      {...props}
    >
      <div className={slots.container()}>
        <div className={slots.titleSection()}>{titleSection}</div>
        <div className={slots.top()}>
          {bannersProduct.map((item, index) => {
            return (
              <div
                className={slots.itemTop()}
                key={index}
                onClick={() => emblaApi?.scrollTo(index)}
                role="button"
                tabIndex={0}
              >
                <div
                  className={slots.titleProduct({
                    activeItem: activeSlide === index
                  })}
                >
                  {item.title}
                </div>
                <Image
                  className={slots.iconTop()}
                  src={staticMediaUrl('about/ecobiology/product/Icon.png')}
                  alt="Banner"
                  width={12}
                  height={12}
                />
              </div>
            );
          })}
        </div>
        <UiKitCarouselBase
          className={slots.carousel()}
          arrowPrevClass={slots.arrowPrev()}
          arrowNextClass={slots.arrowNext()}
          viewportClassName="overflow-visible"
          showArrows
          fade
          onSlidesChange={handleSlideChange}
          loop={false}
          options={{
            watchDrag: false
          }}
          onInit={setEmblaApi}
        >
          {bannersProduct.map((item, index) => {
            const slideSlots = styles({ mode: item.mode });

            return (
              <div
                key={index}
                className={slots.banner()}
              >
                <div className={slideSlots.bgImageWrapper()}>
                  <UiModArtDirection
                    className={slots.bgImage()}
                    images={[
                      { src: item.productImage, media: '(min-width: 640px)' },
                      { src: item.productImageMobile }
                    ]}
                    alt={item.title}
                  />
                </div>

                <ProductSliderInfo
                  items={item.infoProduct}
                  mode={item.mode}
                />
              </div>
            );
          })}
        </UiKitCarouselBase>
      </div>
    </div>
  );
}
